module.exports = "/static/assets/7240b7511b6569a32adc182e980cb5e4.svg";